export default __webpack_public_path__ + "static/media/lb-ab.43c1e908.webp";